<template>
  <div v-if="report.companyoverview.creditreport">
    <report-panel :report="report" :anchor="anchor">
      <div slot="title">Credit History</div>
      <div slot="body">
        <table class="table table-striped" id="credit-history-table">
          <thead>
            <tr>
              <th>Start Date</th>
              <th>End Date</th>
              <th style="text-align: right">Score</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="score in report.companyoverview.creditreport.creditscores.slice(0, 5)"
              :key="score.id"
            >
              <td>{{ isEmptyMessage(formatDate(score.start_date)) }}</td>
              <td>{{ isEmptyMessage(formatDate(score.end_date)) }}</td>
              <td style="text-align: right">{{ isEmptyMessage(score.value) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report', 'showAnchor'],
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#credit';
      }
      return '';
    },
  },
};
</script>
